import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/authContext";

const Drafts = () => {
  const { currentUser } = useContext(AuthContext);
  const [drafts, setDrafts] = useState([]);

  useEffect(() => {
    const fetchDrafts = async () => {
      try {
        const res = await axios.get("/api/posts/drafts");
        setDrafts(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchDrafts();
  }, []);

  if (currentUser?.username !== "emma20106") {
    return (
      <div className="add-picture">
        <h2>Sorry, only the blog owner can view drafts!</h2>
      </div>
    );
  }

  return (
    <div className="posts-page">
      <h1>drafts</h1>
      <div className="posts">
        {drafts.length === 0 ? (
          <p>No drafts saved.</p>
        ) : (
          drafts.map((post) => (
            <div className="post" key={post.id}>
              <div className="content">
                <h1>{post.title || "(untitled)"}</h1>
                <Link className="link" to="/write" state={post}>
                  <button>Continue editing</button>
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Drafts;
